// initialize smooth scroll
new GambitSmoothScroll();

window.$ = window.jQuery;
window.mobileBreakpoint = 630;
window.tabletBreakpoint = 767;

import fixedNav from './fixedNav';
import hamburger from './hamburgerNav';
import featuredHeroScroll from './featuredHeroScroll';
import materialLanding from './material-landing';
import materialDetail from './material-detail';
import featureVideo from './featureVideo';
import Parallax from './vendor/parallax-scroll';
import coverVid from 'covervid';
import svg4everybody from 'svg4everybody';

require('viewport-units-buggyfill').init();
require('waypoints/lib/jquery.waypoints');
require('waypoints/lib/shortcuts/sticky');

// svg sprite support for IE
svg4everybody();

const $window = $(window);
const $document = $(document);

function parallaxCaption() {
  if(window.innerWidth > mobileBreakpoint) {
    const parallax = new Parallax('.c-photo-grid__caption', {
      speed: 0.05, // Anything over 0.5 looks silly
    });

    parallax.animate();
  }
}

$document.ready(() => {
  materialDetail();
  materialLanding();
  fixedNav();
  hamburger();
  parallaxCaption();
  featureVideo();
  featuredHeroScroll();

  // on mobile, we don't want the homepage hero columns to be clickable, only the buttons below it.
  $('.c-feature-hero__col').on('click', (e) => {
    if(window.innerWidth <= mobileBreakpoint) {
      e.preventDefault();
    }
  });

  $('.js-scroll-down').on('click', (e) => {
    let section = $('section:visible')[1];
    let topPos = $(section).offset().top - $('.c-header').outerHeight();

    $('html, body').stop().animate({ scrollTop: topPos }, 'slow');
  });

  $('.slick-slider').slick({
    adaptiveHeight: true,
    speed: 500,
    prevArrow: '<div class="slick-prev"><span>Previous</span></div>',
    nextArrow: '<div class="slick-next"><span>Next</span></div>'
  });

  $('.c-work__media--slideshow').slick({
    adaptiveHeight: true,
    speed: 500,
    dots: true,
    prevArrow: '<div class="slick-prev"><span>Previous</span></div>',
    nextArrow: '<div class="slick-next"><span>Next</span></div>'
  });
});

$window.on('load', () => {
  let waypoints = $('.h-waypoint').waypoint({
      handler: function(direction) {
          if(direction == "down"){
            $(this.element).addClass('is-loaded');
          }
      },
      offset: '100%'
    });
});

$window.on('resize', () => {
  parallaxCaption();
});
